"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _useRendererStyles = _interopRequireDefault(require("./styles/useRendererStyles"));
/**
 * Accepts markup drawn from the RTE and renderers it with all the requisite styles.
 */
var RichTextRenderer = function RichTextRenderer(props) {
  var content = props.content,
    className = props.className;
  var classes = (0, _useRendererStyles.default)(props);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(className, classes.root)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ql-editor",
    dangerouslySetInnerHTML: {
      __html: content
    }
  }));
};
RichTextRenderer.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes.default.object,
  /**
   * Class name to be applied to the `RichTextRenderer` container.
   */
  className: _propTypes.default.string,
  /**
   * `RichTextEditor` content rendered and displayed by the `RichTextRenderer`.
   *
   * **Important Note:** If you need to provide HTML content to the `RichTextRenderer` from an untrusted source, please ensure that the HTML is sanitized before rendering.
   */
  content: _propTypes.default.string
};
var _default = exports.default = RichTextRenderer;